import { type ComponentProps, useId, useState } from "react";

export function PasswordInput({ id, ...props }: Omit<ComponentProps<"input">, "type">) {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [visible, setVisible] = useState(false);
  return (
    <span className="password-input">
      <input {...props} id={inputId} type={visible ? "text" : "password"} />
      <button
        type="button"
        className="text-button password-input__toggle"
        aria-controls={inputId}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        onClick={() => setVisible((current) => !current)}
      >
        {visible ? "Hide" : "Show"}
      </button>
    </span>
  );
}
